import { getBffLoginQueryKey } from "@vega-api/generated/authorization-bff/authorization-bff";
import { type FrontendPortal } from "@vega-api/generated/types/frontendPortal";
import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { m } from "@vega-core/paraglide/messages";
import { LocalStorageService } from "@vega-core/service/LocalStorage.service";
import { isLocal } from "@vega-core/utils/global";
import { isFalsy } from "@vega-core/utils/isFalsy";

type Props = {
  source: FrontendPortal;
  variant?: "primary" | "secondary";
};

export const BffLoginButton = ({ source, variant = "primary" }: Props) => {
  const handleClick = () => {
    if (isFalsy(source)) {
      return;
    }

    LocalStorageService.removeAllTokens();

    const [path] = getBffLoginQueryKey(source);
    // Backend OAuth client registration requires _LOCAL suffix for localhost URLs
    const finalPath = isLocal() ? `${path}_LOCAL` : path;
    window.location.assign(finalPath);
  };

  return (
    <ThemedButton
      data-analytics="gtm-bff-authorize"
      dataTestId="bff-sign-in-button"
      disabled={isFalsy(source)}
      fullWidth
      onClick={handleClick}
      variant={variant}
    >
      {m.auth_login_with_ssoV2()}
    </ThemedButton>
  );
};
